<style scoped>
.fa-file-upload {
  font-size: 128px;
}
label {
  font-weight: bold;
  text-transform: uppercase;
  color: #373e46;
}

i {
  color: white !important;
}

a.btn {
  margin-bottom: 2em;
}

#fileUpload {
  margin-bottom: 1em;
}
</style>

<template>
<div 
     id="fileUpload"
     v-show="shouldShow()">
  <div >
    <label :for="getConfig('wizard')">
      <span v-if="item.response_private">
        <i class="fa fa-lock"></i>
      </span>
      {{item.label | multitranslate}}
      <span v-if="item.required">*</span>
    </label>
  </div>
  <div class="w-100 d-flex flex-wrap">
    <!-- <div v-show="images.length > 0" class="d-flex flex-wrap">-->
    <div class="d-flex flex-wrap">
        <div class="card" v-for="(image, index) in images">
          <img :src="image.preview"
               class="card-img-top"
               alt="">
          <div class="card-body">
            <a href="#"
               class="btn"
               v-on:click.prevent="deleteImg(index)">
              <i class="fas fa-times d-block w-100 text-right pr-1"></i>
            </a>
          </div>
        </div>
      <div>
        <a href="#" v-show="images.length < imageMax"
           class="btn btn-upload text-gray-500"
           @click.prevent="triggerAddFile">
          <i class="fas fa-plus text-gray-500"></i>
        </a>
      </div>
    </div>
  </div>
  <div style="display:none;">
    <input type="file"
           :ref="'file'+index"
           v-for="(item, index) in (images.length + 1)"
           :id="'upload-'+index"
           @change="addFile" />
  </div>
<p class="text-primary d-block text-right w-100 font-weight-bold"> {{images.length}} / {{imageMax }}</p>
</div>
</template>

<style scoped>
  a.btn, .btn, .card{
    width: calc(100vw /5);
    height: calc(100vw /5);
    margin-bottom: 10px;
    display: flex;
    padding: 0;
    margin-right: 10px;
  }
  .btn-upload{
    background-color: white;
    border: dashed 3px;
    justify-content:center;
    align-items: center;
    padding: auto;
  }
  .card-img-top{
    object-fit: fill;
    height: 100%;
    width: 100%;
  }
  a.btn-upload i{
    color: inherit!important;
  }
  .card-body{
    position: absolute;
    top: 0;
    background-color: transparent;
    padding: 0;
    left: 0;
    color: white;
  }
  label {
    font-weight: bold;
    text-transform: uppercase;
    font-family: Montserrat, sans-serif, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    color :#373e46;
  }
</style>

<script>
import AbstractForm from './AbstractForm.vue'
import Compressor from 'compressorjs';
import {
  EventManager
} from '@/components/Events/EventManager.js'
export default {
  extends: AbstractForm,
  components: {
    EventManager
  },
  name: 'FormFileUpload',
  created() {
    this.imageMax = this.item.cardinality
  },
  data() {
    return {
      imageMax: 0,
      nbImage: 0,
      images: [],
      maxWidth: 1200,
      maxHeight: 1200
    }
  },
  methods: {
    triggerAddFile: function() {
      document.getElementById('upload-' + this.images.length).click()
    },
    addFile: function(event) {
      var that = this
      if (this.images.length >= this.imageMax) {} else {
        new Compressor(event.target.files[0], {
          quality: 0.8,
          maxWidth: this.maxWidth,
          maxHeight: this.maxHeight,
          success(file) {
            var fr = new FileReader()
            fr.onload = function(e) {
              that.images.push({
                file: file,
                preview: e.target.result
              })
              that.emitFile()
            }
            fr.readAsDataURL(file)
          },
          error(e) {
            console.log(e.message);
          },
        });
      }
      // if (this.images.length >= this.imageMax) {} else {
      //   var file = event.target.files[0]
      //   var fr = new FileReader()
      //   fr.onload = function(e) {
      //     that.images.push({
      //       file: file,
      //       preview: e.target.result
      //     })
      //     that.emitFile()
      //   }
      //   fr.readAsDataURL(file)
      // }
    },
    emitFile: function() {
      var content = {}
      for (var i = 0; i < this.images.length; i++) {
        content[i] = this.images[i].file
      }
      var data = {
        key: this.item.key,
        content: content
      }
      EventManager.$emit('file-selected', data)
    },
    deleteImg: function(index) {
      this.images.splice(index, 1)
      this.emitFile()
    }
  }
}
</script>
